var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 345.362,
    height: 333.987,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 9131.42 8830.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 3613.71,
    y1: 109.39,
    x2: 5574.15,
    y2: 8625.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#02718c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#4f9caf"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.83 257.56c-394.51 0-279.89-21.79-465.94-34.34v7434.91c0 396.16-60.13 709.36 369.05 937.09 653.81 346.89 1979.03 212.63 2765.75 196.33 102.66-2.13 316.06-19.98 408.16-29.69 158.54-16.74 272.01-10.89 429.87-29.27l1661.77-129.49c127.34-6.98 296.2-18.33 407.51-30.2 150.79-16.08 284.02-11.51 435.69-24.53l1718.84-83.23c311.22.16 565.32-17.16 889.55-17.16V6353.14c0-717.57 21.17-1378.8 21.17-2094.83v-3159.4c0-261.96-37.26-844.01 21.2-1047.42-170.78 0-725.14 103.02-1355.52 103.02-350.87 0-719.82-24.43-1056.27-70.89-272.11-37.58-573.8-99.95-875.1-69.73-320.6 32.17-484.71 120.98-746.16 202.14-291.1 90.35-563.97 127.36-923.06 127.36-549.79 0-1019.15-324.98-1849.33-343.41h-144.93c-244.77 5.16-519.79 37.15-835.07 110.16-230.58 53.37-611.3 147.4-877.17 147.4z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M468.83 257.56c-394.51 0-279.89-21.79-465.94-34.34v7434.91c0 396.16-60.13 709.36 369.05 937.09 653.81 346.89 1979.03 212.63 2765.75 196.33 102.66-2.13 316.06-19.98 408.16-29.69 158.54-16.74 272.01-10.89 429.87-29.27l1661.77-129.49c127.34-6.98 296.2-18.33 407.51-30.2 150.79-16.08 284.02-11.51 435.69-24.53l1718.84-83.23c311.22.16 565.32-17.16 889.55-17.16V6353.14c0-717.57 21.17-1378.8 21.17-2094.83v-3159.4c0-261.96-37.26-844.01 21.2-1047.42-170.78 0-725.14 103.02-1355.52 103.02-350.87 0-719.82-24.43-1056.27-70.89-272.11-37.58-573.8-99.95-875.1-69.73-320.6 32.17-484.71 120.98-746.16 202.14-291.1 90.35-563.97 127.36-923.06 127.36-549.79 0-1019.15-324.98-1849.33-343.41h-144.93c-244.77 5.16-519.79 37.15-835.07 110.16-230.58 53.37-611.3 147.4-877.17 147.4z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.83 257.56c-394.51 0-279.89-21.79-465.94-34.34v7434.91c0 396.16-60.13 709.36 369.05 937.09 653.81 346.89 1979.03 212.63 2765.75 196.33 102.66-2.13 316.06-19.98 408.16-29.69 158.54-16.74 272.01-10.89 429.87-29.27l1661.77-129.49c127.34-6.98 296.2-18.33 407.51-30.2 150.79-16.08 284.02-11.51 435.69-24.53l1718.84-83.23c311.22.16 565.32-17.16 889.55-17.16V6353.14c0-717.57 21.17-1378.8 21.17-2094.83v-3159.4c0-261.96-37.26-844.01 21.2-1047.42-170.78 0-725.14 103.02-1355.52 103.02-350.87 0-719.82-24.43-1056.27-70.89-272.11-37.58-573.8-99.95-875.1-69.73-320.6 32.17-484.71 120.98-746.16 202.14-291.1 90.35-563.97 127.36-923.06 127.36-549.79 0-1019.15-324.98-1849.33-343.41h-144.93c-244.77 5.16-519.79 37.15-835.07 110.16-230.58 53.37-611.3 147.4-877.17 147.4z",
    style: {
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSea);
export default __webpack_public_path__ + "static/media/sea.38b5fca28f4c4026455e021213e479bb.svg";
export { ForwardRef as ReactComponent };